/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import moment from 'moment/moment';
import PropTypes from 'prop-types';
import { Row, Col, Container, Form, Button, Spinner } from 'react-bootstrap';
import { RiArrowGoBackFill } from 'react-icons/ri';
import { useRouter } from 'next/router';
import React, { useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { translate as t } from 'utils/helpers';
import { detectMobileBrowser } from 'components/Utilities';
import styles from './NewsletterPreview.module.scss';
import useLang from '../../context/LanguageContext';
import PublicFooter from '../Footer/PublicFooter';
import SharePopup from '../Toast/SharePopup';
import { subscribeCreator } from '../../apis/creator-page';
import routes from '../../utils/routes';

const NewsletterPreview = ({ newsletterData, isPreview, host, isShare }) => {
  const date =
    newsletterData?.status === 'sent'
      ? newsletterData?.published_at
      : newsletterData?.schedule_date;
  const router = useRouter();
  const { lang } = useLang();

  const [modalShow, setModalShow] = useState(!!isShare);
  const [loading, setLoading] = useState(false);

  const { errors, register, handleSubmit, reset, setError } = useForm({});

  const formRef = useRef(null);

  const openSharingBox = () => {
    const isMobBrowser = detectMobileBrowser();
    if (isMobBrowser && navigator.share) {
      const shareData = {
        url: newsletterData?.domain_redirect_url,
        text: newsletterData?.name,
        description: newsletterData?.description,
      };
      navigator.share(shareData);
    } else {
      setModalShow(true);
    }
  };

  const handleSubscribeClick = async (data) => {
    setLoading(true);
    const formData = new FormData();

    for (const key in data) {
      formData.append(key, data[key]);
    }

    const response = await subscribeCreator(formData);
    if (response?.status === 200 || response?.status === 201) {
      toast.success('Subscribed Successfully');
      reset();
    } else {
      for (const key in response?.data) {
        setError(key, {
          type: 'manual',
          message: response?.data[key][0],
        });
      }
      formRef.current.scrollIntoView({ behavior: 'smooth' });
    }
    setLoading(false);
  };

  return (
    <Container className={`wider ${styles.container}`}>
      <section className={`${styles.newsletterDetail} pb-4`}>
        {isPreview && (
          <div onClick={() => router.back()} className={styles.backButton}>
            <RiArrowGoBackFill />
          </div>
        )}
        <Row>
          {newsletterData?.newsletter_settings?.logo_webp && (
            <Col xs={{ span: 12, order: 1 }} md={{ span: 4, order: 2 }}>
              <img
                className={styles.newsletterImg}
                src={newsletterData?.newsletter_settings?.logo_webp}
                alt="publication cover"
                loading="lazy"
              />
            </Col>
          )}
          <Col xs={{ span: 12, order: 2 }} md={{ span: 8, order: 1 }}>
            <p className={styles.sectionHeading}>{newsletterData?.name}</p>
            <div className={styles.sectionDescription}>
              <section
                className={styles.contentSection}
                dangerouslySetInnerHTML={{
                  __html: newsletterData?.description,
                }}></section>
              <p>
                {moment(date).format('MMM D')}&nbsp; •&nbsp;
                <a
                  href={
                    newsletterData?.newsletter_settings?.creator_redirect_url ||
                    '#'
                  }
                  alt="Link to creator">
                  {' '}
                  {newsletterData?.newsletter_settings?.publication_name}{' '}
                  {t(lang, 'newsletter')('by')}{' '}
                  {newsletterData?.newsletter_settings?.creator_name}
                </a>
              </p>
            </div>
          </Col>
          <Col xs={{ span: 12, order: 3 }}>
            <div onClick={openSharingBox} style={{ cursor: 'pointer' }}>
              <img
                src="/other-icons/resend.png"
                alt="resend icon"
                width="33"
                loading="lazy"
              />
            </div>
          </Col>
        </Row>
      </section>

      <hr />

      <section
        className={styles.contentSection}
        dangerouslySetInnerHTML={{
          __html: newsletterData?.content,
        }}></section>

      <hr />

      {!isPreview && (
        <Row className={styles.subscriptionSection} id="subscribe">
          <Col md={12}>
            <div className={`${styles.content} text-md-center`}>
              <h2 className={styles.title}>
                {newsletterData?.creator_settings?.form_cta_title}
              </h2>
              <p className={styles.text}>
                {newsletterData?.creator_settings?.form_cta_text}
              </p>
            </div>
          </Col>
          <Col md={12}>
            <Form
              className="form"
              ref={formRef}
              noValidate
              onSubmit={handleSubmit(handleSubscribeClick)}>
              <Row>
                <Col md={4}>
                  <Form.Group className="floating">
                    <Form.Control
                      type="text"
                      ref={register({
                        required: 'Name is required',
                      })}
                      required
                      isInvalid={!!errors?.name}
                      name="name"
                    />
                    <Form.Label>{t(lang, 'creator')('name')}</Form.Label>
                  </Form.Group>
                  <Form.Control.Feedback type="invalid">
                    {errors?.name?.message}
                  </Form.Control.Feedback>
                </Col>
                <Col md={4}>
                  <Form.Group className="floating">
                    <Form.Control
                      type="text"
                      ref={register({
                        required: 'Email is required',
                      })}
                      required
                      isInvalid={!!errors?.name}
                      name="email"
                    />
                    <Form.Label>
                      {t(lang, 'creator')('emailAddress')}
                    </Form.Label>
                  </Form.Group>
                  <Form.Control.Feedback type="invalid">
                    {errors?.email?.message}
                  </Form.Control.Feedback>
                </Col>
                <Col xs={{ order: 2 }} md={{ span: 4, order: 1 }}>
                  <Button
                    id="subscribeButtonBottom"
                    variant="primary"
                    type="submit"
                    style={{
                      color: newsletterData?.creator_settings?.text_color,
                      backgroundColor:
                        newsletterData?.creator_settings?.button_color,
                      borderColor:
                        newsletterData?.creator_settings?.button_color,
                    }}
                    disabled={loading}>
                    {loading ? (
                      <Spinner
                        as="span"
                        animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      newsletterData?.creator_settings?.form_cta_button ||
                      t(lang, 'common')('subscribe')
                    )}
                  </Button>
                </Col>
                <Col
                  xs={{ span: 12, order: 1 }}
                  md={{ order: 2 }}
                  className="text-left text-md-center">
                  <Form.Check
                    type="checkbox"
                    name="terms_and_condition"
                    className="custom-checkbox mb-2 mb-md-0"
                    ref={register({
                      required: t(lang, 'creator')('termsError'),
                    })}
                    // isInvalid={!!errors?.terms_and_condition}
                    label={
                      <div>
                        <span>{t(lang, 'account')('termsAgree')} </span>
                        <a
                          href={`${routes.privacyPolicy(lang)}#terms`}
                          target="_blank">
                          {t(lang, 'account')('termsAnchorText')}
                        </a>
                      </div>
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.terms_and_condition &&
                      errors?.terms_and_condition?.message}
                  </Form.Control.Feedback>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      )}

      <PublicFooter langChanger={false} lang={lang} />

      <SharePopup
        show={modalShow}
        host={host}
        modalTitle={t(lang, 'common')('share')}
        shareText={newsletterData?.name}
        shareUrl={newsletterData?.domain_redirect_url}
        onHide={() => setModalShow(false)}
        hideVia
      />
    </Container>
  );
};

NewsletterPreview.propTypes = {
  newsletterData: PropTypes.object,
  isPreview: PropTypes.bool,
  host: PropTypes.string,
  isShare: PropTypes.bool,
};

export default NewsletterPreview;
